import React, { useState } from 'react';
import { Modal, ModalContent, ModalBody, ModalHeader } from '@/components/modal';

interface DeleteFileConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void; // Triggered when the user confirms the delete action
    fileName: string;
}

const DeleteFileModal: React.FC<DeleteFileConfirmationModalProps> = ({
                                                                         open,
                                                                         onClose,
                                                                         onConfirm,
                                                                         fileName,
                                                                     }) => {
    const [inputValue, setInputValue] = useState<string>('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    // User must type the exact file name to enable the "Confirm" button
    const isConfirmButtonEnabled = inputValue === fileName;

    return (
        <Modal open={open} onClose={onClose} className="!flex items-center justify-center">
            <ModalContent className="max-w-md w-full p-6">
                <ModalHeader className="p-0 border-0">
                    <div className="flex items-center justify-between flex-wrap grow gap-5 pb-5">
                        <h1 className="text-lg font-semibold leading-none text-gray-900">
                            Delete File
                        </h1>
                        <button className="btn btn-sm btn-light" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </ModalHeader>
                <ModalBody className="scrollable-y py-0 mb-5 ps-0 pe-3 -me-5.5">
                    <p className="text-sm text-gray-700 pb-3">
                        Are you sure you want to delete the file{' '}
                        <span className="font-semibold text-gray-900">{fileName}</span>? This action
                        cannot be undone. Please type the file name below to confirm.
                    </p>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        placeholder="Type file name to confirm"
                        className="border border-gray-400 p-3 rounded-md text-sm w-full focus:outline-none"
                    />
                    <div className="flex justify-end gap-2 mt-4">
                        <button className="btn btn-sm btn-light" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={onConfirm}
                            disabled={!isConfirmButtonEnabled}
                        >
                            Confirm
                        </button>
                    </div>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export { DeleteFileModal };
